import MetricCard from "../components/MetricCard";

function money(value) {
  const amount = Number(value || 0);
  return `$${amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function changeLabel(value) {
  if (value === null || value === undefined) return null;
  const amount = Number(value);
  if (!Number.isFinite(amount)) return null;
  return `${amount >= 0 ? "+" : ""}${amount.toFixed(1)}%`;
}

function RevenueOverview({ sales }) {
  const revenueMetrics = [
    { id: "today", label: "Sales Today", value: money(sales?.today), change: changeLabel(sales?.today_change_percent), trend: Number(sales?.today_change_percent || 0) < 0 ? "down" : "up", helperText: "Compared with yesterday", icon: "today" },
    { id: "month", label: "This Month", value: money(sales?.month), change: changeLabel(sales?.month_change_percent), trend: Number(sales?.month_change_percent || 0) < 0 ? "down" : "up", helperText: "Compared with last month", icon: "month" },
    { id: "lifetime", label: "Lifetime Sales", value: money(sales?.lifetime), change: null, trend: null, helperText: "Total completed sales", icon: "lifetime" },
  ];

  return (
    <section className="revenue-overview">
      {revenueMetrics.map((metric, index) => (
        <MetricCard key={metric.id} {...metric} variant={index === 0 ? "featured" : "default"} />
      ))}
    </section>
  );
}

export default RevenueOverview;
